import React from 'react';

const Error = ({children}) => {
	return (
		<div className="text-right text-sm text-primary py-1">{children}</div>
	);
};

export default Error;